import { FunctionComponent } from "react";
import { FieldErrors, UseFormRegister } from "react-hook-form";
import {
  RadioGroupWithRegister,
  TextInputWithRegister,
} from "src/components/inputs";
import { NEATTOptions } from "src/utils/types";

interface ILendingPurposeFormProps {
  register: UseFormRegister<any>
  errors: FieldErrors;
  seekingLoan?: string;
  concernedAboutProcess?: string;
}

const LendingPurposeForm: FunctionComponent<ILendingPurposeFormProps> = ({ register, errors, seekingLoan, concernedAboutProcess }) => (
  <form className="grid grid-cols-2 gap-4">
    <RadioGroupWithRegister
      question="Are you trying to get a loan?"
      name="seekingLoan"
      register={register}
      options={NEATTOptions.YesNoOptions}
    error={`${errors?.seekingLoan?.message || ""}`}
    />

    {seekingLoan === NEATTOptions.YesNoUnsure.YES && (
      <>
        <RadioGroupWithRegister
          question="What kind of loan are you trying to obtain?"
          name="loanType"
          register={register}
          options={NEATTOptions.LoanTypeOptions}
          error={`${errors?.loanType?.message || ""}`}
        />

        <TextInputWithRegister
          register={register("loanamount")}
          label="Loan Amount"
          id="loanamount"
          placeholder="00.00"
          error={errors?.loanamount?.message}
        />
      </>
    )}

    <RadioGroupWithRegister
      question="Are you open to exploring alternative loan options?"
      name="openToExploring"
      register={register}
      options={NEATTOptions.YesNoUnsureOptions}
      error={`${errors?.openToExploring?.message || ""}`}
    />

    <RadioGroupWithRegister
      question="Are you interested in government-backed loan programs?"
      name="governmentBackedLoans"
      register={register}
      options={NEATTOptions.YesNoUnsureOptions}
      error={`${errors?.governmentBackedLoans?.message || ""}`}
    />

    <RadioGroupWithRegister
      question="Are you concerned about the loan process?"
      name="activeConcerns"
      register={register}
      options={NEATTOptions.YesNoOptions}
      error={`${errors?.activeConcerns?.message || ""}`}
    />

    {concernedAboutProcess === NEATTOptions.YesNoUnsure.YES && (
      <TextInputWithRegister
        register={register("reasonforconcerns")}
        label="Reason for concerns"
        id="reasonforconcerns"
        placeholder="reason..."
        error={errors?.reasonforconcerns?.message}
      />
    )}
  </form>
);

export default LendingPurposeForm;
